import * as React from 'react';
import styled from 'styled-components';
import ButtonMain from '../atoms/ButtonMain';

const PermitMenu = ({ tabs, activeTab }: Props) => {
  return (
    <MenuWrapper>
      {tabs.map(tab => (
        <ButtonWrapper key={tab.id}>
          <ButtonMain
            variant={
              tab.id === activeTab ? 'contained' : 'text'
            }
            onClick={tab.action}
          >
            {tab.title}
          </ButtonMain>
        </ButtonWrapper>
      ))}
    </MenuWrapper>
  );
};

interface Props {
  tabs: Array<Tab>;
  activeTab: number;
}

interface Tab {
  id: number;
  title: string;
  action: () => void;
}

const MenuWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 24px 0px;
  flex-wrap: wrap;
  gap: 6px;

  @media (max-width: 840px) {
    margin: 14px 0;
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  @media (max-width: 540px) {
    margin: 10px 0;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  /* 7 tabs share the row; subtract the 6 inter-item gaps (6px each) so the
     last tab (Conditions) doesn't overflow and wrap onto a second row. */
  width: calc((100% - 36px) / 7);
  justify-content: center;

  @media (max-width: 840px) {
    width: auto;
    flex: 1 1 100px;
    min-width: 100px;
  }

  @media (max-width: 540px) {
    flex: 0 0 auto;
    min-width: 90px;
  }
`;

export default PermitMenu;
